import PropTypes from "prop-types";

const GalleryViewTooltip = ({ localisedValues }) => {
    return (
        <div className='custom-tooltip-content text-nowrap' data-testid='galleryViewTooltip'>
            <div className='custom-tooltip-in'>
                <p>{localisedValues["pin_a_video_tile_above_to_use_this_feature"]}</p>
            </div>
        </div>
    );
};
GalleryViewTooltip.propTypes = {
    localisedValues: PropTypes.object,
};
export default GalleryViewTooltip;
